// extracted by mini-css-extract-plugin
module.exports = {"embedEdit":"Embed_embedEdit__3KLjs","btnActive":"Embed_btnActive__3qtP0","popup-wrapper":"Embed_popup-wrapper__jYYEe","popup":"Embed_popup__2U7io"};